import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { UnlocodeService } from 'src/app/services/unlocode.service';

@Pipe( {
    name: 'unlocodeName',
    standalone: true
} )
export class UnlocodeNamePipe implements PipeTransform {
    #unlocodeService = inject( UnlocodeService );

    transform( code: string ): Observable<string> {
        return this.#unlocodeService.getUnlocodeName( code );
    }

}
